'use client';

import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RelatedWork = ({ cases, onViewCase, className = '' }) => {
  return (
    <section className={`py-4 bg-muted ${className}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-4">
          <h2 className="text-3xl md:text-4xl font-headline font-black text-foreground mb-4">
            Related Work
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore more transformative projects that deliver measurable results
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {cases.map((relatedCase) => (
            <div
              key={relatedCase.id}
              className="bg-card rounded-lg overflow-hidden shadow-subtle hover:shadow-dramatic transition-all duration-300 group cursor-pointer"
              onClick={() => onViewCase(relatedCase.id)}
            >
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={relatedCase.image}
                  alt={relatedCase.alt}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground to-transparent opacity-60" />
              </div>

              <div className="p-6">
                <div className="flex flex-wrap gap-2 mb-3">
                  {relatedCase.services.slice(0, 2).map((service, index) => (
                    <span
                      key={index}
                      className="bg-muted text-foreground text-xs font-bold px-3 py-1 rounded-full"
                    >
                      {service}
                    </span>
                  ))}
                </div>

                <h3 className="text-xl font-headline font-bold text-foreground mb-2 line-clamp-2">
                  {relatedCase.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">{relatedCase.client}</p>

                <div className="flex items-center text-primary font-semibold text-sm group-hover:translate-x-2 transition-transform duration-300">
                  <span>View Case Study</span>
                  <Icon name="ArrowRightIcon" size={16} className="ml-2" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedWork;
